// @flow

import * as React from 'react';

type Props = {| children: ((?HTMLElement) => void, ?HTMLElement) => React.Node |};
class Target extends React.Component<Props, { target: ?HTMLElement }> {
  state = { target: null };

  componentDidMount() {
    this.setState({ target: this.renderTimeTarget });
  }

  setTarget = (ref: ?HTMLElement) => {
    this.renderTimeTarget = ref;
  };

  renderTimeTarget = null;

  render() {
    return this.props.children(this.setTarget, this.state.target);
  }
}

export default Target;
